import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@strands/ui/components/alert-dialog";

interface DeleteSessionDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
}

export function DeleteSessionDialog({ open, onCancel, onConfirm }: DeleteSessionDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent className="gap-0 rounded-2xl p-7 pb-7 shadow-[var(--shadow-02)] ring-0 max-w-[27rem]! sm:max-w-[27rem]!">
        <AlertDialogHeader className="text-left">
          <AlertDialogTitle className="text-[13px] font-medium text-foreground-secondary">
            Удалить чат
          </AlertDialogTitle>
          <AlertDialogDescription className="mt-3 text-[17px] font-semibold leading-6 tracking-[-0.3px] text-foreground text-wrap!">
            Вы уверены, что хотите удалить этот чат?<br />Это действие нельзя отменить.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mx-0! mb-0! mt-5 flex-row gap-2.5 border-t-0 bg-transparent p-0">
          <AlertDialogCancel className="flex-1 rounded-xl py-2.5" onClick={onCancel}>Отмена</AlertDialogCancel>
          <AlertDialogAction variant="destructive" className="flex-1 rounded-xl py-2.5" onClick={onConfirm}>Удалить</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
